export default __webpack_public_path__ + "57b720fc1d01c9bcbfb3ee7d9ab01297.png";